import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import TabDatiRiepilogoTitolareEff from '../sezione/TabDatiRiepilogoTitolareEff';
import DatiRelazContr from '../sezione/DatiRelazContr';
import DatiGeneraliFisico from '../sezione/DatiGeneraliFisico';
import DatiGeneraliMinimi from '../sezione/DatiGeneraliMinimi';
import DatiResidenza from '../sezione/DatiResidenza';
import DatiDomicilio from '../sezione/DatiDomicilio';
import DatiRecapito from '../sezione/DatiRecapito';
import DatiAntiriciclaggio from '../sezione/DatiAntiriciclaggio';
import DatiAttivitaEconomica from '../sezione/DatiAttivitaEconomica';
import DatiFiscali from '../sezione/DatiFiscali';

import ButtonComp from '../../common/ButtonComp';
import DividerComp from '../../common/DividerComp';

import { trovaDatiTitolareEffInList, toNumber } from '../../../utility/genericUtility';
import { locale_it, TITOLARE_EFF_BENEF_MORTE, 
	      CODICE_SAE_FIDUCIARIA_AMMINISTRAZIONE, CODICE_SAE_FIDUCIARIA_GESTIONE, 
	      CODICE_QUALIFICA_FIDUCIANTE } from '../../../utility/jsConstants';
import { creaTitolareEff } from '../../../utility/objectUtility';
import { errorFiducianteMorte } from '../../../utility/storeUtility';
import { isTcmIndividualeValida } from '../../../utility/tcmIndividualeUtility';
	      
import * as actions from './action/titolareEff';
import * as actionType from './actionType/titolareEff';
import * as actionsBenef from './action/beneficiarioMorte';
import * as actionTypeBenef from './actionType/beneficiarioMorte';
import * as actionGeneric from '../../generic/action/generic';
import * as actionTypeGeneric from '../../generic/actionType/generic';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: theme.button,
    textField: theme.textField,
    textErrorMessage: theme.textErrorMessage,
});


const mapStateToProps = state => {
    return {
        titolareEffBenefMorteValida: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.anagraficaValida,
        datiGeneraliMinimiTitEffBenef: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.datiTitolareBenefMorteEff.datiGeneraliMinimi,
        controlloDati: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.controlloDati,
        salvaTitolareEffBenefMorteSuccess: state.areaBenefMorteReducer.salvaTitolareEffBenefMorteSuccess,
        titolareEffBenefMorteList: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorteList,
        titolareBenefMorteEff: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte,
        datiRelazContr: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.datiTitolareBenefMorteEff.datiRelazContr,
        benefMorteSae: state.areaBenefMorteReducer.benefMorteGiuridico.datiAttEconomica.codSAE,
        datiTitolareEff: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.datiTitolareBenefMorteEff,
        isFiduciariaFromCopia: state.areaBenefMorteReducer.benefMorteGiuridico.datiCopiaDaAltraFigura.isFiduciaria,
        scopeTcmEmissione: state.genericReducer.generic.proposalInfo.scopeTcmEmissione,
        tcmIndividualeValida: state.genericReducer.generic.proposalInfo.tcmIndividualeValida,
        errorFiducianteContoProprio: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.errorFiducianteContoProprio,
        errorFiducianteContoTerzi: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.errorFiducianteContoTerzi,
        errorFiducianteInLista: state.areaBenefMorteReducer.benefMorteGiuridico.titolareEffBenefMorte.errorFiducianteInLista,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateDatiGeneraliMinimiTitolareEffBenefMorte: (unDato, unActionType) => dispatch(actions.updateDatiGeneraliMinimiTitolareEffBenefMorte(unDato, unActionType)),
        confermaAggiungiTitolareEffBenefMorte: (currTitolareEff) => dispatch(actions.confermaAggiungiTitolareEffBenefMorte(currTitolareEff)),
        nuovoTitolareEffBenefMorte: () => dispatch(actions.nuovoTitolareEffBenefMorte()),
        updateTitolareEffBenefMorte: (currTitolareEff) => dispatch(actions.updateTitolareEffBenefMorte(currTitolareEff)),
        aggiungiTitolareAlProprioBenefMorteGiuridico: (currTitolareEff) => dispatch(actionsBenef.aggiungiTitolareAlProprioBenefMorteGiuridico(currTitolareEff)),
        setGeneric: (unDato, unaLabel, unActionType) => dispatch(actionGeneric.setGeneric(unDato, unaLabel, unActionType)),
    }
}



class TitolareEffBenefMorteAss extends React.Component {
    constructor(props) {
        super(props);
        //    console.log('#RTCFA TitolareEffAss constructor props', this.props);
        this.state = {
            percentualeTotale: 0,
            isConfermaTitEffBenefMorte: false,
            isNuovoTitEffBenefMorte: false,
            statoCampi: this.initStatoCampi(),
            isPresenteErrore: null,
        }
    };

    getIsFiduciaria = () => {
        let isFiduciaria = false;
        if(this.props.isFiduciariaFromCopia) {
            isFiduciaria = true;
        } else {
            isFiduciaria =
            this.props.benefMorteSae === CODICE_SAE_FIDUCIARIA_AMMINISTRAZIONE 
         || this.props.benefMorteSae === CODICE_SAE_FIDUCIARIA_GESTIONE;
        }
        return isFiduciaria;
    }

    initStatoCampi = () => {
        return [{ id: 'datiGeneraliMinimi', isError: false },

        ];
    }

    handleError = (id, isError) => {
        let unErrore = null;
        let campoOnId = this.state.statoCampi.filter(unCampo => unCampo.id === id);
        let campoWithoutId = this.state.statoCampi.filter(unCampo => unCampo.id !== id);
        if (campoOnId.length > 0) {
            unErrore = campoOnId[0];
            unErrore.isError = isError;
        } else {
            unErrore = { id: id, isError: isError };
        }
        this.setState({
            statoCampi: [...campoWithoutId, unErrore],
        });
    }

    handleClickConfermaTitolareEffBenefMorte = (event) => {
        this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(true, actionType.SALVA_TITOLARE_EFF_BENEF_MORTE);
        this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(false, actionType.SALVA_TITOLARE_EFF_BENEF_MORTE_SUCCESS);
        this.setState({
            isConfermaTitEffBenefMorte: true,
            isNuovoTitEffBenefMorte: false,
        })
    }

    handleClickNuovoTitolareEffBenefMorte = (event) => {
        this.props.nuovoTitolareEffBenefMorte();
        this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(false, actionType.SALVA_TITOLARE_EFF_BENEF_MORTE_SUCCESS);
        this.setState({
            isConfermaTitEffBenefMorte: false,
            isNuovoTitEffBenefMorte: true,
            isPresenteErrore: null,
        })
    }

    controllaFiducianteMorte = (prevProps, prevState) => {
    	const isFiduciaria = this.getIsFiduciaria();
        const errFiduciante = errorFiducianteMorte(isFiduciaria, undefined);
        
        if (errFiduciante.errFiducianteContoProprio !== this.props.errorFiducianteContoProprio) {
	       this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(errFiduciante.errFiducianteContoProprio, actionTypeBenef.UPDATE_ERRORE_FIDUCIANTE_TE_BENEF_MORTE_CONTO_PROPRIO);
        }
        if (errFiduciante.errFiducianteContoTerzi !== this.props.errorFiducianteContoTerzi) {
        	this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(errFiduciante.errFiducianteContoTerzi, actionTypeBenef.UPDATE_ERRORE_FIDUCIANTE_TE_BENEF_MORTE_CONTO_TERZI);
        }
        if (errFiduciante.errFiducianteInLista !== this.props.errorFiducianteInLista) {
        	this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(errFiduciante.errFiducianteInLista, actionTypeBenef.UPDATE_ERRORE_FIDUCIANTE_TE_BENEF_MORTE_IN_LISTA);
        }
	    
	    return errFiduciante;	
    }
    
    confermaTitolareEffBenefMorte = () => {

    	/*2026-01-19 PFD: Gestione Fiduciaria Conto Proprio Conto Terzi
        this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(errorFiducianteMorte(this.getIsFiduciaria()), actionTypeBenef.UPDATE_ERRORE_FIDUCIANTE_TE_MORTE);
    	*/
    	
    	const isFiduciaria = this.getIsFiduciaria();
        const currTitEff = this.props.titolareBenefMorteEff;
        const anagraficaValidaBenefMorte = this.props.titolareEffBenefMorteValida;
        if (anagraficaValidaBenefMorte === true) {
            let isNuovo = false;
            // Trova per Codice Fiscale
            //const datiTitEffInLista = trovaDatiTitolareEffInList(this.props.titolareEffBenefMorteList, currTitEff, locale_it);
            
            let datiTitEffInLista = null;      
            const codiceFiscaleTitEff = isFiduciaria ? currTitEff.datiTitolareBenefMorteEff.datiGenerali.codiceFiscale : currTitEff.datiTitolareBenefMorteEff.datiGeneraliMinimi.codiceFiscale
            this.props.titolareEffBenefMorteList.map((item, index, array) => {
                const datiGeneraliItem = isFiduciaria ? item.datiTitolareBenefMorteEff.datiGenerali : item.datiTitolareBenefMorteEff.datiGeneraliMinimi
                if (datiGeneraliItem.codiceFiscale === codiceFiscaleTitEff) {
                    datiTitEffInLista = item;
                }	
            });	
                
            // Edit figura corrente
            if (!datiTitEffInLista) {
                isNuovo = true;
            }
            // INSERIMENTO NUOVO TITOLARE EFFETTIVO
            if (isNuovo === true) {
                if (this.props.titolareEffBenefMorteList.length < 4){
                    this.props.confermaAggiungiTitolareEffBenefMorte(currTitEff);
                    this.props.aggiungiTitolareAlProprioBenefMorteGiuridico(currTitEff);
                }
            } else {
                // MODIFICA TITOLARE EFFETTIVO
                this.props.updateTitolareEffBenefMorte(currTitEff);
            }
            
            //2021-07-01 PFD: TCM_INDIV
            this.handleTcmIndividualeValida();
        }       
    }

    //2021-07-01 PFD: TCM_INDIV
    //Logica introdotto per i Prodotti in scope TCM_EMISSIONE (TZSEV988) 
    //Se alcune condizioni su Premio/PEP Anagrafiche/Relazioni Paesi Black List sono verificate non sono obbligatori alcuni campi rif.: TCM individuali_v.1.8.doc
    handleTcmIndividualeValida = () => {	
	  if (this.props.scopeTcmEmissione) {
	    const isTcmIndValida = isTcmIndividualeValida(locale_it);
	  	// se cambiata 
	  	if ( isTcmIndValida !== this.props.tcmIndividualeValida ){
	  	  this.props.setGeneric(isTcmIndValida, "", actionTypeGeneric.TCM_INDIVIDUALE_VALIDA);
	  	}
	  } 
    }
    
    /* errorFiduciante = () => {
        const isFiduciaria = this.getIsFiduciaria();
        const currentTit = this.props.titolareBenefMorteEff;
        const titList = this.props.titolareEffBenefMorteList;
        let isFiducianteCurrent = false;
        let isPresenteFiducianteInList = false;
        if(currentTit.datiTitolareBenefMorteEff.datiAntiriciclaggio.qualifica === CODICE_QUALIFICA_FIDUCIANTE) {
          isFiducianteCurrent = true;
        }
        if(titList.length > 0 && titList[0].datiTitolareBenefMorteEff) {
          titList.map((el, i) => {
            if(el.datiTitolareBenefMorteEff.datiAntiriciclaggio.qualifica === CODICE_QUALIFICA_FIDUCIANTE) {
              isPresenteFiducianteInList = true;
            }
          });
        }
        let presente = (isFiducianteCurrent === true || isPresenteFiducianteInList === true) ? true : false;
        if(isFiduciaria) {
            return !presente;
        } else {
            return presente;
        }
      } */

    render() {
        const { classes, datiTitolareEff, t } = this.props;
        const datiGeneraliMinimi = this.props.datiGeneraliMinimiTitEffBenef;
        const datiRelazContr = this.props.datiRelazContr;
        const controlloDati = this.props.controlloDati;
        const isNuovo = this.state.isNuovoTitEff;
        const percentualeTotaleError = this.state.percentualeTotale !== 0 && parseFloat(this.state.percentualeTotale) > 100.0;
        const isFiduciaria = this.getIsFiduciaria();
        
        const errFiducianteContoProprio = this.props.errorFiducianteContoProprio;
        const errFiducianteContoTerzi = this.props.errorFiducianteContoTerzi;
        const errFiducianteInLista = this.props.errorFiducianteInLista;
        
        return (
            <Fragment>
                <TabDatiRiepilogoTitolareEff figura={TITOLARE_EFF_BENEF_MORTE} tabHeader={'tabHeaderTitolareEffBenef'} titolareEffList={this.props.titolareEffBenefMorteList} />
                
                {(!isFiduciaria) ?
                <>
                    <DatiRelazContr figura={TITOLARE_EFF_BENEF_MORTE} datiRelazContr={datiRelazContr}  onError={this.handleError} controlloDati={controlloDati} relazioneConContr={'relazioneTitolareContrMorte'}/>
                    <DatiGeneraliMinimi id={'datiGeneraliMinimi'} datiGeneraliMinimi={datiGeneraliMinimi} onError={this.handleError} controlloDati={controlloDati}
                        figura={TITOLARE_EFF_BENEF_MORTE} />
                </>
                :
                <>
                <Grid container direction='row' justify='center' alignItems='flex-start'>
                    <DatiGeneraliFisico figura={TITOLARE_EFF_BENEF_MORTE} datiGeneraliTitolareEff={datiTitolareEff.datiGenerali} labelFieldSet='datiGenerali'  
                                        id={'datiGeneraliTitolareEff'} onError={this.handleError} isFiduciaria={isFiduciaria} />
                    <DatiResidenza figura={TITOLARE_EFF_BENEF_MORTE} datiResidenzaTitolareEff={datiTitolareEff.datiResidenza} 
                                    id={'datiResidenzaTitolareEff'} onError={this.handleError} isFiduciaria={isFiduciaria} />
                    <DatiDomicilio figura={TITOLARE_EFF_BENEF_MORTE} datiDomicilioTitolareEff={datiTitolareEff.datiDomicilio} id='datiDomicilioTitolareEff' 
                                    onChildrenError={this.handleError} labelFieldSet='datiDiDomicilioTitolareEff' isFiduciaria={isFiduciaria} />
                    <DatiRecapito figura={TITOLARE_EFF_BENEF_MORTE} datiRecapitoTitolareEff={datiTitolareEff.datiRecapito} labelFieldSet='indirizzoDiCorrispondenza' id={'datiRecapitoTitolareEff'}
                                    onError={this.handleError} isFiduciaria={isFiduciaria} />
                    <DatiAttivitaEconomica figura={TITOLARE_EFF_BENEF_MORTE} datiAttEconomicaTitolareEff={datiTitolareEff.datiAttEconomica} labelFieldSet='datiAttivitaEconomica' 
                                            id={'datiAttEconomicaTitolareEff'} onError={this.handleError} isFiduciaria={isFiduciaria} />
                </Grid>
                <DividerComp titolo='datiAntiriciclaggioTitolareEff' variant='subtitle1'/>
                <Grid container direction='row' justify='center' alignItems='flex-start'>
                    <DatiAntiriciclaggio figura={TITOLARE_EFF_BENEF_MORTE} datiAntiriciglaggio={datiTitolareEff.datiAntiriciglaggio} 
                                        id={'datiAntiriciclaggioTitolareEff'} onError={this.handleError} isFiduciaria={isFiduciaria} />
                    <DatiFiscali figura={TITOLARE_EFF_BENEF_MORTE} datiFiscali={datiTitolareEff.datiFiscali} labelFieldSet='datiFiscaliTitolareEff'
                                id={'datiFiscaliTitolareEff'} onError={this.handleError} isFiduciaria={isFiduciaria} />
                </Grid>
                </>
                }

                <Grid container direction='row' justify='center' alignItems='center'>
                    <Grid item>
                        {(controlloDati === true) && (this.state.isPresenteErrore === true) &&
                            <Typography className={classes.textErrorMessage}>{t('datiNonValidi')}</Typography>
                        }
                        {(controlloDati === true) && !this.state.isPresenteErrore && percentualeTotaleError && !isNuovo &&
                            <Typography className={classes.textErrorMessage}>{t('errTotPercTitEff')}</Typography>
                        }
                        {(controlloDati === true) && (this.state.isPresenteErrore === false) && !isNuovo &&
                            <Typography className={classes.textErrorMessage}>{t('datiValidi')}</Typography>
                        }
                        {/*
                        {(controlloDati === true) && (errorFiducianteMorte(this.getIsFiduciaria())) &&
                            <Typography className={classes.textErrorMessage}>{t('erroreFiduciante')}</Typography>
                        }
                        */}
                        {(controlloDati === true) && (errFiducianteContoProprio) &&
                          <Typography className={classes.textErrorMessage}>{t('erroreFiducianteContoProprio')}</Typography>
                        }
                        {(controlloDati === true) && (errFiducianteContoTerzi) &&
                          <Typography className={classes.textErrorMessage}>{t('erroreFiducianteContoTerzi')}</Typography>
                        }
                        {(controlloDati === true) && (errFiducianteInLista) &&
                          <Typography className={classes.textErrorMessage}>{t('erroreFiducianteInLista')}</Typography>
                        }
                        {(controlloDati === true) && (this.props.titolareEffBenefMorteList.length === 4) &&
                            <Typography className={classes.textErrorMessage}>{t('massimoTitEff')}</Typography>
                        }
                    </Grid>
                </Grid>

                <Grid container>
                <Grid xs={3}></Grid>
                <Grid xs={3} item>
                    <ButtonComp
                        /* to={linkTo} */
                        /* component={Link} */
                        aClassName={classes.button}
                        buttonLabel={t('conferma')}
                        onClick={this.handleClickConfermaTitolareEffBenefMorte}
                    />
                </Grid>
                <Grid xs={3} item>
                    <ButtonComp
                        /* to={linkTo} */
                        /* component={Link} */
                        aClassName={classes.button}
                        buttonLabel={t('nuovoTitEff')}
                        onClick={this.handleClickNuovoTitolareEffBenefMorte}
                    />
                <Grid xs={3}></Grid>
                </Grid>
                </Grid>

            </Fragment >
        )
    }

    isConfermaTitolareEffBenefMorte = (prevProps, prevState) => {
    	//2026-01-19 PFD: Gestione Fiduciaria Conto Proprio Conto Terzi
    	// Tolto controllo this.props.titolareEffAnagraficaValida perche deve eseguire controllaFiducianteMorte
        /*if(this.state.isConfermaTitEffBenefMorte && this.props.titolareEffBenefMorteValida) {*/
    	if(this.state.isConfermaTitEffBenefMorte) {
    		const errorFiduciante = this.controllaFiducianteMorte(prevProps, prevState);    		
    		if (errorFiduciante.errFiducianteContoProprio === false && errorFiduciante.errFiducianteContoTerzi===false) {
    			this.confermaTitolareEffBenefMorte();
    		}
    		
    		this.setState({
	            isConfermaTitEffBenefMorte: false,
	        });
        }
    }

    isError(prevProps, prevState) {
        let isPresenteCampiConErrore = false;
        this.state.statoCampi.map(unoStatoCampo => {
            return (
                isPresenteCampiConErrore = isPresenteCampiConErrore || unoStatoCampo.isError
                                            || this.props.errFiducianteContoProprio
				                            || this.props.errorFiducianteContoTerzi 
				                      /*    || this.props.errorFiducianteInLista  */
            );
        });
        if (this.state.isPresenteErrore !== isPresenteCampiConErrore && (this.props.controlloDati !== '')) {
            this.props.updateDatiGeneraliMinimiTitolareEffBenefMorte(!isPresenteCampiConErrore, actionType.UPDATE_ANAGRAFICA_VALIDA_TITOLARE_EFF_BENEF_MORTE);
            this.setState({
                isPresenteErrore: isPresenteCampiConErrore,
            });
        }
    }



    componentDidUpdate(prevProps, prevState) {
        this.isError(prevProps, prevState);
        this.isConfermaTitolareEffBenefMorte(prevProps, prevState);
        if(this.props.titolareEffBenefMorteList.length <= 0 && this.props.titolareEffBenefMorteList.length !== prevProps.titolareEffBenefMorteList.length) {
            this.setState({
                isPresenteErrore: true
            })
        }
    }
}


TitolareEffBenefMorteAss.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withStyles(styles)(TitolareEffBenefMorteAss)));